import { For } from "solid-js";
import type { JSX } from "solid-js";
import type { Task } from "../../../types/Task";
import { getFulfilmentStatus, STATUS_MAP } from "../../../utils/taskUtil";
import { ViewTaskUserModal } from "./ViewTaskModal";
import { useTranslation } from "../../../state/i18n";
import { useModalManager } from "../../../components/modal/ModalManager";
import ButtonLink from "../../../components/link/ButtonLink";
import Pill from "../../../components/pill/Pill";

type TaskRecipientsCellContentProps = {
  task: Task;
};

const TaskRecipientsCellContent = (props: TaskRecipientsCellContentProps): JSX.Element => {
  const { t } = useTranslation();
  const { open } = useModalManager();

  return (
    <ul>
      <For each={props.task.users}>
        {({ userId, username }) => {
          const fulfilment = props.task.fulfilments[userId.toString()];
          const status = getFulfilmentStatus(fulfilment) ?? STATUS_MAP[props.task.status];

          return (
            <li class="flex">
              <ButtonLink
                label={username}
                classList={{ grow: true }}
                onClick={() =>
                  open({
                    content: () => <ViewTaskUserModal username={username} fulfilment={fulfilment} status={status} />,
                  })
                }
              />
              <span>
                <Pill label={t(status.label)} variant={status.variant} />
              </span>
            </li>
          );
        }}
      </For>
    </ul>
  );
};

export default TaskRecipientsCellContent;
